module.exports = __webpack_public_path__ + "img/Boton-de-cierre.55be86b1.svg";